import React, { useEffect, useState } from 'react';
import { apiGet } from '../api';
import '../components/Blog.css';

export default function MlBlogPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(9);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        const resp = await apiGet('/api/posts', { locale: 'ml', page, pageSize });
        const arr = Array.isArray(resp?.items) ? resp.items : [];
        if (!ignore) {
          const mapped = arr.map((p) => ({
            id: p.id,
            slug: p.slug,
            title: p.title,
            excerpt: p.excerpt || '',
            date: p.date,
            category: (p.category && (p.category.name || p.category.slug)) || 'post',
            image: p.imageUrl || undefined,
            type: p.isAd ? 'ad' : 'post',
            adText: p.adText || undefined,
            ctaText: p.ctaText || undefined,
          }));
          setItems(mapped.filter((m) => m.title && m.type === 'post'));
          setTotal(Number(resp?.total || 0));
        }
      } catch (_) {
        if (!ignore) {
          setItems([]);
          setTotal(0);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <section className="blog-section" style={{ paddingTop: '24vh' }}>
      <div className="container">
        <div className="blog-header">
          <h2 className="blog-title">പുരയിടകൃഷി ബ്ലോഗ് — എല്ലാ പോസ്റ്റുകളും</h2>
          <p className="blog-subtitle">മലയാളം ലേഖനങ്ങളുടെ സമ്പൂർണ്ണ പട്ടിക</p>
        </div>

        {loading && <div style={{ marginBottom: 12 }}>Loading…</div>}

        <div className="blog-grid">
          {items.map((post) => (
            <article key={post.id} className={`blog-card`} onClick={() => { if (post.slug) window.location.hash = `#/blog/ml/${encodeURIComponent(post.slug)}`; }} style={{ cursor: 'pointer' }}>
              <div className="blog-image">
                <img
                  src={post.image}
                  alt={post.title}
                  onError={(e) => { e.currentTarget.src = `https://via.placeholder.com/400x250/2d5016/ffffff?text=${encodeURIComponent(post.category)}`; }}
                />
                <div className={`blog-category`}>{post.category}</div>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-date">{post.date}</span>
                </div>
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>
              </div>
            </article>
          ))}
          {!loading && items.length === 0 && (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#666' }}>പോസ്റ്റുകൾ ഒന്നുമില്ല</div>
          )}
        </div>

        <div className="blog-footer" style={{ justifyContent: 'space-between' }}>
          <button className="view-all-posts" onClick={() => { window.location.hash = '#'; }}>ഹോം പേജിലേക്ക് മടങ്ങുക</button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="view-all-posts" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>മുമ്പത്തെ</button>
            <span style={{ alignSelf: 'center' }}>{page} / {totalPages}</span>
            <button className="view-all-posts" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>അടുത്തത്</button>
          </div>
        </div>
      </div>
    </section>
  );
}
